import { filter } from 'rxjs';

export const skipUndefined = () => filter(v => v !== undefined)
